var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M72.963 14.8701V9.88061C72.963 4.70812 68.7549 0.5 63.5824 0.5H16.4175C11.245 0.5 7.03686 4.70812 7.03686 9.88061V14.8701C2.99484 15.9136 0 19.5907 0 23.9542V50.6622H7.03686V55.3554H11.7244V50.6622H68.2755V55.3554H72.963V50.6622H79.9998V23.9542C79.9998 19.5907 77.005 15.9136 72.963 14.8701ZM11.7244 9.88076C11.7244 7.2928 13.8297 5.18749 16.4175 5.18749H63.5824C66.1702 5.18749 68.2755 7.2928 68.2755 9.88061V14.8701C64.2335 15.9136 61.2386 19.5907 61.2386 23.9542V25.646H18.7612V23.9543C18.7612 19.5909 15.7664 15.9137 11.7244 14.8703V9.88076ZM61.2386 30.3335V35.0285H42.3437V30.3335H61.2386ZM37.6562 30.3335V35.0285H18.7612V30.3335H37.6562ZM75.3124 45.9748H4.68749V23.9542C4.68749 21.3664 6.7928 19.2611 9.38061 19.2611C11.9684 19.2611 14.0737 21.3664 14.0737 23.9542V39.716H65.926V23.9542C65.926 21.3664 68.0313 19.2611 70.6191 19.2611C73.2069 19.2611 75.3124 21.3664 75.3124 23.9542V45.9748Z",
    fill: "#C49A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility10);
export default __webpack_public_path__ + "static/media/gefion-facility-10.170f437f0975f35add231456a6a7cad4.svg";
export { ForwardRef as ReactComponent };